import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router } from "@angular/router";
import { AccountFacade } from "@youm-front/account/data-access";
import { CONF2_QUERY_PARAMS } from "@youm-front/conf2/domain";
import { of } from "rxjs";
import { mergeMap } from "rxjs/operators";

@Injectable()
export class AuthorizeGuard {
  constructor(
    private readonly router: Router,
    private readonly accountFacade: AccountFacade
  ) {}

  canActivate(route: ActivatedRouteSnapshot) {
    const { roomId } = route.params;

    const token = route.queryParamMap.get("token");
    if (token) {
      return true;
    }

    // Avoid redirecting to the 'invitation' page for a few seconds (until auth is done)
    const conf2Jwt = route.queryParamMap.get(CONF2_QUERY_PARAMS.jwt);
    if (conf2Jwt) {
      return true;
    }

    return this.accountFacade.authorized$.pipe(
      mergeMap((_) =>
        _ ? of(true) : [this.router.createUrlTree([roomId, "invitation"])]
      )
    );
  }
}
